import React from 'react'

const Impressum = (props) => {
  return (
    <>
      {props.language === 1 ? (
        <section className="legal">
          <div>
            <h1>Impressum</h1>
            <h2>Gesetzliche Anbieterkennung:</h2>
            <p>
              Ingrid Fuerbass
              <br />
              Oberntorwall 21
              <br />
              33602 Bielefeld
              <br />
              Deutschland
              <br />
              Telefon: +491719350723
              <br />
              E-Mail: info@fashionmonks.com
            </p>
          </div>
        </section>
      ) : (
        <section className="legal">
          <div>
            <h1>Imprint</h1>
            <p>
              Ingrid Fuerbass
              <br />
              Oberntorwall 21
              <br />
              33602 Bielefeld
              <br />
              Deutschland
              <br />
              Telefon: +491719350723
              <br />
              E-Mail: info@fashionmonks.com
            </p>
          </div>
        </section>
      )}
    </>
  )
}

export default Impressum
